import React from 'react';
import { JWInput } from '../brand';
import { SearchIcon } from 'lucide-react';

interface SearchInputProps {
    placeholder: string
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void
    onSearchClick: () => void
    className?: string
}

const SearchInput: React.FC<SearchInputProps> = ({
    placeholder,
    onChange,
    onKeyDown,
    onSearchClick,
    className,
}) => {
    return (
        <div className="flex items-center w-full">
            <div className="relative flex-grow">
                <JWInput
                    className={`bg-lightblue-100 border-0 w-full pr-8 pl-3 py-1 text-sm dark:bg-jw-surface-2 dark:text-jw-ink dark:placeholder:text-jw-ink-2 ${className}`}
                    placeholder={placeholder}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                />
                <button
                    className="absolute inset-y-0 right-2 flex items-center justify-center hover:bg-transparent"
                    style={{ pointerEvents: 'auto', transition: 'none' }}
                    onClick={onSearchClick}
                    tabIndex={0}
                    aria-label="Search"
                    onMouseDown={(e) => {
                        // Prevent focus outline when clicking with mouse
                        e.currentTarget.classList.remove('focus-visible');
                        document.body.classList.remove('user-is-tabbing');
                    }}
                >
                    <SearchIcon className="h-5 w-5 text-gray-500 dark:text-jw-ink-2" />
                </button>
            </div>
        </div>
    );
};

export default SearchInput;
